import { createIcon } from '../icon'
import HeartIcon from '../svg/HeartIcon'

export const HeartIconDefault = createIcon(HeartIcon)
